import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { HrDashboardService } from '../../../services/hr-dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantRouterService } from '../../../services/tenant-router.service';

@Component({
  selector: 'app-hierarchy',
  standalone: false,
  templateUrl: './hierarchy.component.html',
  styleUrl: './hierarchy.component.scss'
})
export class HierarchyComponent implements OnInit,OnChanges {
  hierarchy: any;
  @Input() tenantId!: number;

  selectedTeam: any = null;

  constructor(private hrDashboardService: HrDashboardService,
    private route: ActivatedRoute, private router: Router, private tenantRouter: TenantRouterService
  ) {}

  ngOnInit(): void {
    // Case: navigation via router
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.loadHierarchy(+params['id']);
      }
    });
  }

   ngOnChanges(): void {
    if (this.tenantId) {
      this.loadHierarchy(this.tenantId);
    }
  }

  loadHierarchy(tenantId: number) {
    this.hrDashboardService.getHierarchy(tenantId).subscribe(data => {
      this.hierarchy = {...data, accounts: data.accounts.map((acc: any) => ({
        ...acc,
        expanded: false,
        selectedManager: null
    }))
  }
  });
  }
  toggleAccount(account: any) {
    account.expanded = !account.expanded;
    account.selectedManager = null;
    this.selectedTeam = null; 
  }
  toggleManager(account: any, manager: any) {
    if (account.selectedManager === manager) {
      account.selectedManager = null;
    } else {
      account.selectedManager = manager;
    }
    this.selectedTeam = null; 
  }
  toggleTeam(team: any) {
    if (this.selectedTeam === team) {
      this.selectedTeam = null; 
    } else {
      this.selectedTeam = team; 
    }
  }

 getBadgeClass(color: string): string {
  switch (color) {
    case 'green': return 'bg-success text-light';
    case 'yellow': return 'bg-warning text-dark';
    case 'red': return 'bg-danger text-light';
    default: return 'bg-secondary text-light';
  }
}

goToUserDetail(userId: string | number): void {
  if (!userId) {
    console.error('UserId is undefined, cannot navigate');
    return;
  }
  this.tenantRouter.navigate(['user-detail', userId]);
}

 goToLinkRoute(route: string): void {
    this.tenantRouter.navigate(route);
  }

}